
import VueGtm from '@gtm-support/vue2-gtm'

export const trackPageView = (app, router) => {
  if (process.env.NODE_ENV === 'production') {
    app.use(VueGtm, {
      id: 'GTM-TVDZLF',
      debug: false,
      vueRouter: router,
    })
  }
}
